var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#FF824A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72917 15.3092L10 13.3508L13.2708 15.33L12.3958 11.6217L15.2708 9.12167L11.4792 8.78834L10 5.28834L8.52083 8.7675L4.72917 9.10084L7.60417 11.6008L6.72917 15.3092ZM4.85417 17.9133L6.20833 12.0592L1.66667 8.12167L7.66667 7.60084L10 2.08L12.3333 7.60084L18.3333 8.12167L13.7917 12.0592L15.1458 17.9133L10 14.8092L4.85417 17.9133Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.1c13ee7fcc7e8c98ebb4a5b605700790.svg";
export { ForwardRef as ReactComponent };